module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comment",
    attrs: {
      "id": 'comment-' + _vm.id
    }
  }, [_c('section', {
    staticClass: "box",
    class: {
      'is-active': _vm.active
    }
  }, [_c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('section', {
    staticClass: "comment-header mb-1"
  }, [_c('section', {
    staticClass: "timestamp-section"
  }, [_c('a', {
    staticClass: "tag is-primary play-tag no-select",
    on: {
      "click": function($event) {
        _vm.jumpToTime()
      }
    }
  }, [_c('PlayIcon'), _vm._v("\n\n            " + _vm._s(_vm.prettyTimeStamp(_vm.start_time, _vm.end_time)))], 1)]), _vm._v(" "), _c('section', {
    staticClass: "user-name-container mt-1"
  }, [_c('section', {
    staticClass: "user-name-section"
  }, [_c('img', {
    staticClass: "image is-32x32 mr-1 rounded",
    attrs: {
      "src": _vm.user.avatar_url
    }
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.user.name || _vm.user.email))])]), _vm._v(" "), _c('UpdatingTime', {
    staticClass: "text-muted",
    attrs: {
      "time": _vm.created_on
    }
  })], 1), _vm._v(" "), (_vm.editing) ? _c('div', {
    staticClass: "time-picker-container"
  }, [_c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startTimeMins),
      expression: "startTimeMins"
    }],
    staticClass: "my-input text",
    attrs: {
      "placeholder": "01",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.startTimeMins)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startTimeMins = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "my-time-divider"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startTimeSecs),
      expression: "startTimeSecs"
    }],
    staticClass: "my-input text",
    attrs: {
      "placeholder": "21",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.startTimeSecs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startTimeSecs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "time-divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endTimeMins),
      expression: "endTimeMins"
    }],
    staticClass: "my-input text",
    attrs: {
      "placeholder": "09",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.endTimeMins)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endTimeMins = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "my-time-divider"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endTimeSecs),
      expression: "endTimeSecs"
    }],
    staticClass: "my-input text",
    attrs: {
      "placeholder": "57",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.endTimeSecs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endTimeSecs = $event.target.value
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), (!_vm.editing) ? _c('p', {
    staticClass: "white-space-pre"
  }, [_vm._v(_vm._s(_vm.body))]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('textarea', {
    directives: [{
      name: "textautosize",
      rawName: "v-textautosize"
    }, {
      name: "select",
      rawName: "v-select"
    }],
    ref: "body",
    staticClass: "textarea",
    attrs: {
      "placeholder": "Add a comment..."
    },
    domProps: {
      "value": _vm.body
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.editing = false
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if (!$event.shiftKey) { return null; }
        _vm.updateComment()
      }]
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "tags"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('Tag', {
      key: tag.id,
      attrs: {
        "id": tag.id,
        "rubric": tag.rubric,
        "color": tag.color,
        "title": tag.title,
        "videoID": _vm.videoID,
        "commentID": _vm.id,
        "editing": _vm.editing,
        "score": _vm.getScore(tag.id),
        "scoreID": _vm.getScoreID(tag.id),
        "owner": tag.user == _vm.user,
        "groupTag": tag.group_tag
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [(!_vm.editing) ? _c('a', {
    staticClass: "no-select",
    on: {
      "click": function($event) {
        _vm.toggleReplytoComment(_vm.cycleID, _vm.videoID, _vm.id)
      }
    }
  }, [_vm._v("Reply")]) : _vm._e(), _vm._v(" "), _c('span', [(_vm.editing) ? _c('button', {
    staticClass: "button is-small is-info",
    class: _vm.updating && 'is-loading',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.updateComment()
      }
    }
  }, [_vm._v("\n                Save\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('button', {
    staticClass: "button is-small is-warning",
    on: {
      "click": function($event) {
        _vm.toggleAddTagModal()
      }
    }
  }, [_vm._v("\n                + Tag\n              ")]) : _vm._e()]), _vm._v(" "), _c('span', [(_vm.editing) ? _c('button', {
    staticClass: "button is-small is-danger",
    class: _vm.deleting && 'is-loading',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.deleteComment()
      }
    }
  }, [_vm._v("\n                Delete\n              ")]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('input', {
    staticClass: "button is-small ",
    attrs: {
      "type": "button",
      "value": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.editComment()
      }
    }
  }) : _vm._e()]), _vm._v(" "), (!_vm.editing && _vm.user.id == _vm.userID) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.editComment()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()])]), _vm._v(" "), (_vm.replies_editing) ? _c('div', {}, [_c('article', [_c('div', {
    staticClass: "content"
  }, [(_vm.replies_editing) ? _c('div', {
    staticClass: "reply-container"
  }, [_c('article', {
    staticClass: "media reply"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "user-name-container"
  }, [_c('div', {
    staticClass: "user-name-section"
  }, [_c('p', {
    staticClass: "image is-32x32 mr-1"
  }, [_c('img', {
    attrs: {
      "src": _vm.replyUser.avatar_url
    }
  })]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.replyUser.name || _vm.replyUser.email))])])]), _vm._v(" "), (_vm.replies_editing) ? _c('textarea', {
    directives: [{
      name: "textautosize",
      rawName: "v-textautosize"
    }, {
      name: "select",
      rawName: "v-select"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.replyText),
      expression: "replyText"
    }],
    staticClass: "textarea reply-textarea",
    attrs: {
      "placeholder": "Add a reply..."
    },
    domProps: {
      "value": (_vm.replyText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replyText = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "button-container mt-2"
  }, [_c('button', {
    staticClass: "button is-small is-primary",
    class: _vm.addingReply && 'is-loading',
    attrs: {
      "disabled": !_vm.replyText,
      "data-balloon": !_vm.replyText && 'Write a reply before submiting',
      "data-balloon-pos": "right"
    },
    on: {
      "click": function($event) {
        _vm.addReply(_vm.cycleID, _vm.videoID, _vm.id)
      }
    }
  }, [_vm._v("\n                          Save\n                      ")]), _vm._v(" "), _c('input', {
    staticClass: "button is-link is-small",
    attrs: {
      "type": "button",
      "value": "Cancel"
    },
    on: {
      "click": function($event) {
        _vm.toggleReplytoComment(_vm.cycleID, _vm.videoID, _vm.id)
      }
    }
  })])])])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "reply-container"
  }, _vm._l((_vm.replies), function(reply) {
    return _c('Reply', {
      key: reply.id,
      attrs: {
        "id": reply.id,
        "body": reply.body,
        "cycleID": _vm.cycleID,
        "videoID": _vm.videoID,
        "commentID": _vm.id,
        "editable": reply.user.id == _vm.replyUser.id,
        "name": reply.user.name || reply.user.email,
        "avatar_url": reply.user.avatar_url,
        "created_on": reply.created_on
      }
    })
  }))])]), _vm._v(" "), _c('AddTagModal', {
    attrs: {
      "show": _vm.showAddTagModal,
      "videoID": _vm.videoID,
      "commentID": _vm.id
    },
    on: {
      "close": function($event) {
        _vm.showAddTagModal = false
      }
    }
  }), _vm._v(" "), _c('AddRubricTagModal', {
    attrs: {
      "show": _vm.showAddRubricTagModal,
      "commentID": _vm.id,
      "cycleID": _vm.cycleID,
      "videoID": _vm.videoID
    },
    on: {
      "close": function($event) {
        _vm.showAddRubricTagModal = !_vm.showAddRubricTagModal
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-2a61fa8d"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Comment.vue
// module id = 999
// module chunks = 0